import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-organization-dialog',
  templateUrl: './remove-organization-dialog.component.html',
  styleUrls: ['./remove-organization-dialog.component.scss']
})
export class RemoveOrganizationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RemoveOrganizationDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: {
      id: string,
      name: string
    },
  ) {}

  onConfirm(id: string) {
    this.dialogRef.close({ id: id });
  }
}
